<m3-lc-app [moduleName]="core" [productCode]="3000" (isLoaded)="isLoaded = true">
    @defer (when isLoaded) {
        <router-outlet></router-outlet>
    } @placeholder {
        <m3-lc-loader />
    }
</m3-lc-app>
